import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import {TextNotFount} from '../../components/Theme/components/cardArticulo.elements';
import {Cardsection} from '../../ui';
import React from 'react';
import {RemoteDataUI} from '../../common/ui/RemoteDataUI';
import {ProductPriceUI} from '../../product/ui/ProductPriceUI';
import {isPending} from '../../common/domain/RemoteData.model';
import {CatalogItemCard} from './CatalogItemCard';
import {ProductFlatPurchaseCardUI} from '../../product/ui/ProductFlatPurchaseCardUI';
import {Spinner} from 'react-bootstrap';

export const CatalogUI = ({ data }) => {
  const { catalogItems, catalogItemPricesRemoteData, activeTab } = data;

  return (
    <>
      {
        catalogItems.length === 0 ? (
          <div className="text-center d-grid justify-content-center align-items-center">
            <div>
              <Inventory2OutlinedIcon />
            </div>
            <TextNotFount>No se han encontrado resultados. <br /> </TextNotFount>
            <a href={'/articulos'} className="text-primary"> Ver todos los productos</a>
          </div>
        ) : (
          <>
            {
              activeTab === 'grid' ? (
                <Cardsection>
                  {
                    catalogItems.map((catalogItem, index) => (
                      <div key={index}>
                        <CatalogItemCard data={{ catalogItem: catalogItem }}>
                          <CatalogItemCard.Price>
                            <RemoteDataUI remoteData={catalogItemPricesRemoteData}>
                              <RemoteDataUI.Pending>
                                <Spinner size="sm" />
                              </RemoteDataUI.Pending>
                              <RemoteDataUI.Failure>
                                <span>Imposible de cargar precios</span>
                              </RemoteDataUI.Failure>
                              <RemoteDataUI.Success>
                                {
                                  (prices) => (
                                    <ProductPriceUI
                                      loading={false}
                                      error={false}
                                      price={prices[catalogItem.pro_codigo]} />
                                  )
                                }
                              </RemoteDataUI.Success>
                            </RemoteDataUI>
                          </CatalogItemCard.Price>
                        </CatalogItemCard>
                      </div>
                    ))
                  }
                </Cardsection>
              ) : (
                <div className="cardList">
                  {
                    catalogItems.map((catalogItem, index) => (
                      <div key={index} className="my-1">
                        <ProductFlatPurchaseCardUI
                          data={{
                            details: { value: catalogItem, loading: false },
                            price: {
                              value: catalogItemPricesRemoteData.value?.[catalogItem.pro_codigo],
                              loading: isPending(catalogItemPricesRemoteData),
                              error: catalogItemPricesRemoteData.error
                            }
                          }}
                        />
                      </div>
                    ))
                  }
                </div>
              )
            }
          </>
        )
      }
    </>
  );
};